import React, { Component } from 'react';
//import { div } from 'react-native';
import ScoreboardInvoertafels from './ScoreboardInvoertafels';
//import Avatar from '@material-ui/core/Avatar';

export default class ScoreboardLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div align="center" style={{ paddingBottom: 8 }}>
          {/* <br /> */}

          {/* <div style={{ fontWeight: 'bold', fontSize: '24' }}>Livescores NK 5 Pins / Biatlon 2019</div>
          <div style={{ fontWeight: 'normal', fontSize: '16' }}>
            Onder Ons '67 te Beverwijk.
            <br />
          </div> */}
        </div>
        <ScoreboardInvoertafels tafel="1-4" vereniging="OnderOns" />
        <ScoreboardInvoertafels tafel="5-8" vereniging="OnderOns" />
      </div>
    );
  }
}
